<div class="block">
  <div class="account__card">
    <h1>Administrationsersättning</h1>
    <div class="block">
      <p class="text--medium thin">
        Här hittar du kvartalsrapporter avseende era investeringar i WOO via WOO Manager. Rapporten är ert faktureringsunderlag för att nyttja de 2 % administrationsersättning som TV4 medger vid self-service-bokningar i WOO Manager enligt mediebyråavtal. Fakturering av respektive kvartal medges upp till 90 dagar från det att rapporten publicerats i WOO Manager.
      </p>
    </div>
    <div class="display--flex view-container align-items--center">
      <div class="left-item">
        @if(isAdminOrPlannerOrAccountingOrSalesManager) {
          <button
            (click)="exportSummary()"
            class="button primary-1"
          >
            Exportera summeringsrapport
          </button>
        }
        @if(isAdmin) {
          <button
            (click)="exportCampaignList()"
            class="button secondary"
          >
            Exportera kampanjrapport
          </button>
        }
      </div>
      <div class="right-item">
        <woo-dropdown
          class="fill"
          [items]="statuses"
          bindLabel="statusValue"
          bindValue="statusKey"
          labelText="Filtrera"
          [(ngModel)]="activeFilter"
          (ngModelChange)="filterChange($event)"
          [clearable]="true"
        ></woo-dropdown>
      </div>
    </div>
    @for(agency of filteredAgencySummaries; track $index) {
      <h3>{{agency.name}}</h3>
      @if(agency.alias !== agency.name) {
        <span class="text--medium">
          {{agency.alias}}
        </span>
      }
      @if(!agency.reports.length) {
        <p>
          Din mediebyrå har tyvärr inte bokat några kampanjer själv under de gångna kvartalen.
        </p>
      }

      @if(agency.reports.length) {
        <table class="table table--woo table--info table--small" >
          <thead>
            <tr>
              <th>År</th>
              <th>Kvartal</th>
              <th>Total administrationsersättning</th>
              <th>Publicerad</th>
              <th>Ladda ned</th>
              @if(isAdminOrPlannerOrAccounting) { <th>Status</th> }
              
            </tr>
          </thead>
          <tbody>
            @for(report of agency.reports; track $index) {
              <tr>
                <td>{{report.year}}</td>
                <td>{{report.quarter}}</td>
                <td>{{report.total | currency : 'kr'}}</td>
                <td>{{report.created_at || report.updated_at | date}}</td>
                <td>
                  @if(report.total !== 0) {
                    <button
                      (click)="export(report.id, agency.name, report.year, report.quarter)"
                      class="link"
                    >
                      Exportera
                    </button>
                  } @else {
                    <span>Ingen rapport</span>
                  }
                </td>
                <td>
                  <woo-dropdown
                    [items]="statuses"
                    bindLabel="statusValue"
                    bindValue="statusKey"
                    [(ngModel)]="report.status"
                    (ngModelChange)="setStatus(report, $event)"
                  ></woo-dropdown>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
      <div class="divider block"></div>
    }
  </div>
</div>
